<template>
  <el-container class="evaluate">
    <el-header style="height: 40px; padding: 15px 30px">
      <header-crunb :crumbList="crumbList"></header-crunb>
    </el-header>
    <div class="container">
      <div class="check-radio">
        <el-radio-group
          v-model="serachType"
          size="medium"
        >
          <el-radio-button
            label="student"
            class="student"
          >学生</el-radio-button>
          <el-radio-button
            label="team"
            class="team"
          >小组</el-radio-button>
        </el-radio-group>
      </div>
      <div
        v-if="serachType == 'student'"
        class="main-box clearfix"
      >
        <div
          class="box fl"
          key="3.1514926"
          @click="goStuPop()"
        >
          <el-image
            class="iconPng"
            :src="allClassPng"
            alt=""
          ></el-image>
          <el-row class="score">
            <el-col
              class="jia"
              :span="12"
            > {{stuTableDate.goodScore}} </el-col>
            <el-col
              class="jian"
              :span="12"
            > {{stuTableDate.badScore}} </el-col>
          </el-row>
          <h1>全班</h1>
        </div>
        <div
          class="box fl"
          v-for="i in stuTableDate.studentList"
          :key="i.id"
          @click="goStuPop(i.userId)"
        >
          <el-image
            class="iconPng"
            :src="stuMethodsPng(i)"
            alt=""
          ></el-image>
          <el-row class="score">
            <el-col
              class="jia"
              :span="12"
            > {{i.evalScoreMap ? i.evalScoreMap.good : "0"}} </el-col>
            <el-col
              class="jian"
              :span="12"
            > {{i.evalScoreMap ? i.evalScoreMap.bad : "0"}} </el-col>
          </el-row>
          <h1>{{i.userName}}</h1>
        </div>
      </div>
      <div
        v-if="serachType == 'team'"
        class="main-box clearfix"
      >
        <div class="scheme-box">
          <span style="font-size:15px">分组方案：</span>
          <el-select
            @change="getGroupData"
            v-model="schemeCode"
            placeholder="请选择分组方案"
            size="small"
          >
            <el-option
              v-for="item in schemeOption"
              :key="item.schemeCode"
              :label="item.schemeName"
              :value="item.schemeCode"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            class="fr el-icon-plus"
            size="small"
            @click="goAddSchemePop"
          > 添加分组方案</el-button>
        </div>
        <div
          class="box-tema fl"
          v-for="i in groupData"
          :key="i.id"
          @click="goEvaTeamPop(i)"
        >
          <div class="clearfix">
            <el-image
              class="iconPng fl"
              :src="groupPng"
              alt=""
            ></el-image>
            <div class="desc fl">
              <h1>{{i.groupName}}</h1>
              <h1>组员: {{i.studentList ? i.studentList.length:"0"}}人</h1>
            </div>
          </div>
          <el-row class="score">
            <el-col
              class="jia"
              :span="12"
            > 表扬： {{i.goodScore || '0'}} </el-col>
            <el-col
              class="jian"
              :span="12"
            > 提醒： {{i.badScore|| '0'}} </el-col>
          </el-row>
        </div>
        <el-button
          class="addbtn box-tema fl el-icon-plus"
          @click="goAddTeamPop"
        ></el-button>
      </div>
    </div>
    <!-- 学生/小组 评价的对话框 -->
    <el-dialog
      class="add-pop pop-stu"
      :visible.sync="popStuEva"
      :close-on-click-modal="false"
      :showClose="false"
      top="6%"
    >
      <template v-slot:title>
        <div class="add-title">{{stuPopName}}</div>
      </template>
      <div v-loading="subLoading">
        <div class="right-box">
          <!-- 图标 -->
          <div class="check-radio">
            <el-radio-group
              v-model="evalType"
              size="medium"
            >
              <el-radio-button
                label="praise"
                class="student"
              >表扬</el-radio-button>
              <el-radio-button
                label="warning"
                class="team"
              >提醒</el-radio-button>
            </el-radio-group>

            <el-button
              class="fr"
              size="small"
              type="primary"
              @click="popStuEva = false"
            >返回</el-button>
          </div>
          <!-- 图标 -->
          <div class="img-box clearfix">
            <template v-if="evalType == 'praise'">
              <div
                v-for="i in stuEvlIconGoodDate"
                :key="i.id"
                class="min-box"
                @click="subStuEvl(i,'good')"
              >
                <div class="con-box">
                  <el-image
                    class="imgpng"
                    :src="i.iconUrl"
                    fit="cover"
                  >
                  </el-image>
                  <div class="fen">{{i.evalScore}}</div>
                  <h2>{{i.evalTitle}}</h2>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="i in stuEvlIconBadDate"
                :key="i.id"
                class="min-box"
                @click="subStuEvl(i,'bad')"
              >
                <div class="con-box">
                  <el-image
                    class="imgpng"
                    :src="i.iconUrl"
                    fit="cover"
                  >
                  </el-image>
                  <div class="fen fenwe">{{i.evalScore}}</div>
                  <h2>{{i.evalTitle}}</h2>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 添加分组方案的对话框 -->
    <el-dialog
      class="add-pop pop-team-scheme"
      :visible.sync="popAddScheme"
      :close-on-click-modal="false"
      :showClose="false"
      top="15%"
    >
      <template v-slot:title>
        <div class="add-title">添加分组方案</div>
      </template>
      <div>
        <div class="right-box">
          <el-input
            placeholder="请输入分组方案名称"
            v-model="schemeName"
            clearable
          >
          </el-input>
        </div>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button
            round
            @click="popAddScheme=false"
            class="cle-btn"
            size="small"
          >取 消</el-button>
          <el-button
            round
            @click="subAddScheme"
            type="primary"
            class="sub-btn"
            :disabled="!schemeName"
            size="small"
          >确定</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 小组新增的对话框 -->
    <el-dialog
      class="add-pop pop-team"
      :visible.sync="popTeamAdd"
      :close-on-click-modal="false"
      :showClose="false"
      top="6%"
    >
      <template v-slot:title>
        <div class="add-title">{{isEditGroup? "编辑" :"创建"}}小组</div>
      </template>
      <div class="clearfix">
        <div class="left-box fl">
          <el-form
            ref="groupForm"
            :rules="rules"
            :model="form"
            label-width="0px"
          >
            <el-form-item label="">
              <el-image
                class="iconPng"
                :src="groupPng"
                fit="cover"
              >
              </el-image>
            </el-form-item>

            <el-form-item
              label=""
              prop="teamName"
            >
              <el-input
                size="small"
                class="input-bot"
                placeholder="小组名称"
                v-model="form.teamName"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="stulist">
            <el-tag
              class="tag-stu"
              :key="i.userId"
              v-for="i in noGrouCheckStuList"
              closable
              :disable-transitions="false"
              @close="noGrouRemoveStu(i.userId)"
            >
              {{ i.userName }}
            </el-tag>
          </div>
        </div>
        <div class="right-box fl">
          <h1>
            选择学生 <span>已选择 {{ noGrouCheckStuList.length }} 名学生</span>
          </h1>
          <!-- <h1 class="no-grou">选择未分组学生</h1> -->
          <el-checkbox-group v-model="noGrouCheckStuList">
            <div
              class="box fl"
              v-for="i in noGrouStuList"
              :key="i.userId"
            >
              <div class="score-rel">
                <el-checkbox
                  :label="i"
                  :key="i.userId"
                  class="score"
                  size="medium"
                  border
                ></el-checkbox>
              </div>
              <el-image
                class="iconPng"
                :src="stuMethodsPng(i)"
                fit="cover"
              > </el-image>
              <h1>{{ i.userName }}</h1>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-button
            v-if="isEditGroup"
            type="text"
            class="del-btn"
            @click="dissolutionTeam"
          >解散小组</el-button>
          <el-button
            round
            @click="cancelAddTeam"
            class="cle-btn"
            size="small"
          >取 消</el-button>
          <el-button
            round
            @click="submitAddTeam"
            type="primary"
            class="sub-btn"
            size="small"
          >确 定</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 小组评价（编辑）的对话框 -->
    <el-dialog
      class="add-pop pop-team-eva"
      :visible.sync="popTeamEva"
      :close-on-click-modal="false"
      :showClose="false"
      top="4%"
    >
      <template v-slot:title>
        <div class="add-title">{{curGroupInfo.groupName}}</div>
      </template>
      <div>
        <div class="right-box clearfix">
          <div class="but-all clearfix">
            <el-button
              class="fr"
              size="small"
              type="primary"
              @click="popTeamEva = false"
            >返回</el-button>
            <el-button
              class="fr edit-btn"
              size="small"
              type="primary"
              @click="showPopEditGroup"
            >编辑小组</el-button>
          </div>
          <div class="elv-tema-box clearfix">
            <el-checkbox-group v-model="checkTeamUserIdList">
              <div
                class="box fl"
                v-for="i in curGroupInfo.studentList"
                :key="i.userId"
              >
                <div class="check-select">
                  <el-checkbox
                    :label="i.userId"
                    :key="i.userId"
                    class="check-box"
                    size="medium"
                    border
                  ></el-checkbox>
                </div>

                <el-image
                  class="iconPng"
                  :src="stuMethodsPng(i)"
                  alt=""
                ></el-image>
                <el-row class="score">
                  <el-col
                    class="jia"
                    :span="12"
                  > {{i.evalScoreMap ? i.evalScoreMap.good:"0"}} </el-col>
                  <el-col
                    class="jian"
                    :span="12"
                  > {{i.evalScoreMap ? i.evalScoreMap.bad:"0"}} </el-col>
                </el-row>
                <h1>{{ i.userName }}</h1>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <div class="dialog-footer">
          <el-checkbox
            v-model="checkTeamUserIdAll"
            :indeterminate="isIndeterminateTeamAll"
            class="allselect-btn"
          >全选</el-checkbox>
          <el-button
            round
            @click="tremEvaPop2"
            :disabled="!checkTeamUserIdList.length"
            type="primary"
            class="sub-btn"
            size="small"
          >小组点评</el-button>
        </div>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderCrunb from "@/components/HeaderCrunb.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
export default {
  components: {
    HeaderCrunb,
  },
  computed: {
    ...mapState(["userInfo", "activeLabelInfo"]),
    schoolInfo() {
      return this.userInfo.teacherInfoList.find(
        (i) => i.classCode == this.$route.query.classCode
      );
    },
    crumbList() {
      return [
        {
          path: "/indexLabel",
          name: "标签 (" + this.activeLabelInfo.menuName + ")",
          id: 1,
        },
        {
          path: "",
          name: this.schoolInfo.gradeName + this.schoolInfo.className,
          id: 2,
        },
      ];
    },
    checkTeamUserIdAll: {
      get() {
        if (
          this.curGroupInfo.studentList &&
          this.checkTeamUserIdList.length ==
            this.curGroupInfo.studentList.length &&
          this.curGroupInfo.studentList.length != 0
        ) {
          return true;
        } else {
          return false;
        }
      },
      set(newValue) {
        if (newValue) {
          this.checkTeamUserIdList = this.curGroupInfo.studentList.map(
            (i) => i.userId
          );
        } else {
          this.checkTeamUserIdList = [];
        }
      },
    },
    isIndeterminateTeamAll: {
      get() {
        if (
          this.curGroupInfo.studentList &&
          (this.checkTeamUserIdList.length ==
            this.curGroupInfo.studentList.length ||
            this.checkTeamUserIdList.length == 0)
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
  },
  data() {
    return {
      allClassPng: require(`@/assets/image/other/all_class.png`),
      groupPng: require(`@/assets/image/other/group_default.png`),
      srcPng:
        "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
      //学生评价
      stuTableDate: [],
      popStuEva: false,
      serachType: "student", //student team
      evalType: "praise",
      //学生评价弹框
      stuPopName: "",
      curStuUserIds: [],
      stuEvlIconDate: [],
      stuEvlIconGoodDate: [],
      stuEvlIconBadDate: [],
      //分组方案
      schemeOption: [],
      schemeCode: "",
      popAddScheme: false,
      schemeName: "",
      //新增/编辑 小组 - 选学生
      isEditGroup: false,
      popTeamAdd: false,
      noGrouStuList: [],
      noGrouCheckStuList: [],
      form: {
        groupPng:
          "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        teamName: "",
      },
      rules: {
        teamName: [
          {
            required: true,
            message: "请输入小组名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: ["change", "blur"],
          },
        ],
      },
      //小组评价
      groupData: [],
      popTeamEva: false,
      curGroupInfo: { studentList: [] },
      checkTeamUserIdList: [],

      subLoading: false, //评价提交时的加载状态
    };
  },
  created() {
    this.init();
    this.getStuEvlIcon();
  },
  methods: {
    async init() {
      //学生
      let stuForm = {
        classCode: this.schoolInfo.classCode, //学科
        disciplineCode: this.schoolInfo.disciplineCode, //学科
        menuCode: this.activeLabelInfo.menuCode,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        schemeCode: "", //分组方案代码
      };
      this.stuTableDate = await postJson(
        "/student/getStudentsByClassCode",
        stuForm
      );
      //分组方案
      let schemeForm = {
        classCode: this.schoolInfo?.classCode, //学科
        teacherId: this.userInfo.userId,
      };
      this.schemeOption = await postData(
        "/teacher/getUserSchemeList",
        schemeForm
      );
      this.schemeCode =
        this.schemeOption.length > 0 ? this.schemeOption[0].schemeCode : "";
      this.getGroupData();
    },
    async getGroupData() {
      //分组
      try {
        let groupForm = {
          classCode: this.schoolInfo.classCode,
          disciplineCode: this.schoolInfo.disciplineCode, //学科
          menuCode: this.activeLabelInfo.menuCode,
          operatorId: this.userInfo.userId,
          schoolCode: this.userInfo.schoolCode,
          schemeCode: this.schemeCode, //分组方案代码
        };
        this.groupData = await postJson("/teacher/getUserGroupList", groupForm);
      } catch (err) {
        console.log("err", err);
        this.groupData = [];
      }
    },
    stuMethodsPng(i) {
      if (i.userLogo) {
        return i.userLogo;
      } else if (i.userSex == "女") {
        return require(`@/assets/image/other/woman_stu.png`);
      } else if (i.userSex == "男") {
        return require(`@/assets/image/other/man_stu.png`);
      } else {
        return require(`@/assets/image/other/man_stu.png`);
      }
    },
    //学生评价标签
    async getStuEvlIcon() {
      let selectForm = {
        disciplineCode: this.schoolInfo.disciplineCode, //学科
        grade: this.schoolInfo.grade, //年级
        menuCode: this.activeLabelInfo.menuCode,
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
      };
      this.stuEvlIconDate = await postJson(
        "/eval-school/getEvalDimensionCustomList",
        selectForm
      );
      if (this.stuEvlIconDate.length > 0) {
        this.stuEvlIconGoodDate = this.stuEvlIconDate.filter(
          (i) => i.evalClassify == "all" || i.evalClassify == "good"
        );
        this.stuEvlIconBadDate = this.stuEvlIconDate.filter(
          (i) => i.evalClassify == "all" || i.evalClassify == "bad"
        );
      } else {
        this.stuEvlIconGoodDate = [];
        this.stuEvlIconBadDate = [];
      }
    },
    //评价学生
    goStuPop(userId) {
      if (userId) {
        this.stuPopName = this.stuTableDate.studentList.find(
          (i) => i.userId == userId
        ).userName;
        this.curStuUserIds = [userId + ""];
      } else {
        //全部学生
        this.stuPopName = "全班";
        this.curStuUserIds = this.stuTableDate.studentList.map(
          (i) => i.userId + ""
        );
      }
      this.popStuEva = true;
    },
    //学生、小组评价
    async subStuEvl(i, evalClassify) {
      console.log("i",i);
      this.subLoading = true;
      try {
        let stuForm2 = {
          attachUrl: "",
          tagCode: "",
          taskCode: "",
          catalogCode: i.catalogCode,
          evalClassify: evalClassify,
          evalCode: i.evalCode,
          evalScore: i.evalScore,
          catalogName: i.catalogName,
          evalFrequency: i.evalFrequency,
          evalTitle: i.evalTitle,
          menuCode: i.menuCode,
          menuName: i.menuName,
          schoolCode: i.schoolCode,
          disciplineCode: i.disciplineCode,
          disciplineName: i.disciplineName,
          iconUrl: i.iconUrl,
          teacherId: this.userInfo.userId,
          teacherName: this.userInfo.userName,
          studentIds:
            this.serachType == "student"
              ? this.curStuUserIds
              : this.checkTeamUserIdList,
          operatorId: this.userInfo.userId,
        };
        await postJson("/eval/saveUserEvalDetailInfo", stuForm2);
        this.subLoading = false;
        this.$message({ type: "success", message: "评价成功", duration: 4000 });
        this.popStuEva = false;
        this.popTeamEva = false;
        this.init();
      } catch (err) {
        this.subLoading = false;
      }
    },
    //添加分组方案
    goAddSchemePop() {
      this.schemeName = "";
      this.popAddScheme = true;
    },
    async subAddScheme() {
      let schemeForm = {
        classCode: this.schoolInfo.classCode,
        operatorId: this.userInfo.userId,
        schemeName: this.schemeName,
        schoolCode: this.userInfo.schoolCode,
      };
      await postJson("/teacher/saveOrUpdateUserScheme", schemeForm);
      this.$message({ type: "success", message: "添加分组方案成功！" });
      this.init();
      this.popAddScheme = false;
    },
    //添加小组
    async goAddTeamPop() {
      this.isEditGroup = false;
      try {
        this.noGrouStuList = await postData("/teacher/getNoGroupStudentList", {
          classCode: this.schoolInfo.classCode,
          schoolCode: this.userInfo.schoolCode,
        });
      } catch (err) {
        this.noGrouStuList = [];
      }
      this.noGrouCheckStuList = [];
      this.form = {
        groupPng:
          "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        teamName: "",
      };
      this.$refs.groupForm && this.$refs.groupForm.resetFields();
      this.popTeamAdd = true;
    },
    //取消添加小组
    cancelAddTeam() {
      this.popTeamAdd = false;
    },
    noGrouRemoveStu(id) {
      this.noGrouCheckStuList = this.noGrouCheckStuList.filter(
        (i) => i.userId != id
      );
    },
    //提交 添加/编辑 小组
    async submitAddTeam() {
      try {
        await this.$refs.groupForm.validate();
        if (this.noGrouCheckStuList.length < 1) {
          this.$message({ type: "warning", message: "请选择未分组学生！" });
          return;
        }
        if (!this.isEditGroup) {
          //新增
          //添加小组
          let { groupCode } = await postJson("/teacher/saveUserGroupInfo", {
            groupName: this.form.teamName,
            operatorId: this.userInfo.userId,
            schemeCode: this.schemeCode,
            schoolCode: this.schoolInfo.schoolCode,
          });
          console.log("组添加成功");
          await postJson("/teacher/saveUserGroupMap", {
            groupCode: groupCode,
            operatorId: this.userInfo.userId,
            schemeCode: this.schemeCode,
            schoolCode: this.schoolInfo.schoolCode,
            studentIds: this.noGrouCheckStuList.map((i) => i.userId),
          });
        } else {
          //编辑
          //编辑小组
          await postJson("/teacher/updateUserGroupInfo", {
            groupName: this.form.teamName,
            operatorId: this.userInfo.userId,
            id: this.curGroupInfo.id,
          });
          console.log("组编辑成功");
          await postJson("/teacher/saveUserGroupMap", {
            groupCode: this.curGroupInfo.groupCode,
            operatorId: this.userInfo.userId,
            schemeCode: this.schemeCode,
            schoolCode: this.schoolInfo.schoolCode,
            studentIds: this.noGrouCheckStuList.map((i) => i.userId),
          });
        }
        this.form.teamName = "";
        this.popTeamAdd = false;
        this.popTeamEva = false;
        this.$message({
          type: "success",
          message: (this.isEditGroup ? "编辑" : "创建") + "小组成功 ！",
        });
        this.getGroupData();
      } catch (err) {
        console.log("err", err);
      }
    },
    async dissolutionTeam() {
      try {
        await this.$confirm("亲, 你确认要解散小组么?", "温馨提示", {
          type: "warning",
          confirmButtonClass: "logout-btn",
        });
        console.log("解散删除小组");
        await postData("/teacher/deleteUserGroupInfo", {
          id: this.curGroupInfo.id,
        });

        this.$message({
          type: "success",
          message: "解散小组成功 ！",
        });
        this.getGroupData();
        this.popTeamAdd = false;
        this.popTeamEva = false;
      } catch (err) {
        console.log("err", err);
      }
    },
    //评价小组
    async goEvaTeamPop(i) {
      this.curGroupInfo = i;
      this.checkTeamUserIdList = [];
      this.popTeamEva = true;
    },
    //点评小组按钮
    tremEvaPop2() {
      this.popStuEva = true;
    },
    async showPopEditGroup() {
      this.isEditGroup = true;
      this.form.teamName = this.curGroupInfo.groupName;
      this.noGrouCheckStuList = this.curGroupInfo.studentList || [];
      try {
        this.noGrouStuList = await postData("/teacher/getNoGroupStudentList", {
          classCode: this.schoolInfo.classCode,
          schoolCode: this.userInfo.schoolCode,
        });
      } catch (err) {
        this.noGrouStuList = [];
      }
      this.popTeamAdd = true;
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.evaluate {
  .container {
    // border: 1px solid #000;
    background-color: #fff;
    padding: 20px;
    /deep/.check-radio {
      // border: 1px solid rgb(48, 13, 202);
      height: 36px;
      text-align: center;
      .el-radio-button__inner {
        padding: 9px 30px;
        border: 1px solid @color;
        color: @color;
      }
      .is-active {
        .el-radio-button__inner {
          color: #fff;
        }
      }
      .student {
        .el-radio-button__inner {
          border-radius: 16px 0px 0px 16px;
        }
      }
      .team {
        .el-radio-button__inner {
          border-radius: 0 16px 16px 0;
        }
      }
    }
    .main-box {
      // border: 1px solid rgb(209, 14, 14);
      padding: 20px 10px;
      .scheme-box {
        // border: 1px solid #000;
        padding: 0px 15px;
      }
      .box {
        cursor: pointer;
        width: 151px;
        height: 151px;
        border: 1px solid #fff;
        margin: 15px;
        padding: 8px 10px;
        border-radius: 5px;
        box-sizing: border-box;
        text-align: center;
        .iconPng {
          border: 1px solid #fff;
          width: 90px;
          height: 90px;
          border-radius: 50%;
        }
        .score {
          // border: 1px solid #000;
          margin-top: -16px;
          .el-col {
            width: 63px;
            height: 22px;
            line-height: 22px;
            color: white;
          }
          .jia {
            border-radius: 10px 0 0 10px;
            background-color: @color;
            // border: 1px solid rgb(76, 38, 146);
          }
          .jian {
            border-radius: 0px 10px 10px 0px;
            background-color: @zong;
            // border: 1px solid rgb(209, 31, 31);
          }
        }
        h1 {
          margin-top: 13px;
          // border: 1px solid #000;
          font-size: 13px;
        }
      }
      .box:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
      .box-tema {
        cursor: pointer;
        width: 215px;
        height: 120px;
        border: 1px solid #eee;
        margin: 13px;
        padding: 12px;
        border-radius: 10px;
        box-sizing: border-box;
        .iconPng {
          // border: 1px solid #eee;
          width: 60px;
          height: 60px;
          border-radius: 5%;
        }
        .desc {
          // border: 1px solid #000;
          padding-left: 20px;
          h1 {
            font-size: 13px;
            line-height: 29px;
          }
        }
        .score {
          // border: 1px solid rgb(214, 19, 19);
          margin-top: 15px;
          .el-col {
            // width: 63px;
            height: 22px;
            line-height: 22px;
            color: white;
            text-align: center;
            font-size: 13px;
          }
          .jia {
            color: @color;
            // border: 1px solid rgb(76, 38, 146);
          }
          .jian {
            color: @zong;
            // border: 1px solid rgb(209, 31, 31);
          }
        }
      }
      .box-tema:hover {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
      .addbtn {
        border: 1px dashed rgb(199, 194, 194);
        font-size: 40px;
      }
    }
  }
  /deep/.add-pop.pop-stu {
    // 新增对话框
    .el-dialog {
      .el-dialog__body {
        padding: 0px 10px;
      }
      .right-box {
        width: 100%;
        // border: 1px solid rgb(211, 40, 40);
        .img-box {
          margin-top: 15px;
          // border: 1px solid #000;
          .min-box {
            // border: 1px solid blue;
            float: left;
            width: 80px;
            margin: 8px;
            cursor: pointer;
            .con-box {
              text-align: center;
              position: relative;
              left: 0px;
              top: 0px;
              .imgpng {
                width: 75px;
                height: 75px;
                border-radius: 50%;
              }
              .fen {
                box-sizing: content-box;
                position: absolute;
                right: 1px;
                top: 0px;
                z-index: 2;
                // padding: 2px 8px;
                // border: 1px solid #000;
                text-align: center;
                line-height: 23px;
                height: 23px;
                width: 23px;
                border-radius: 50%;
                background-color: @color;
                color: #fff;
              }
              .fenwe {
                box-sizing: content-box;
                position: absolute;
                right: 1px;
                top: 0px;
                z-index: 2;
                // padding: 2px 8px;
                // border: 1px solid #000;
                text-align: center;
                line-height: 23px;
                height: 23px;
                width: 23px;
                border-radius: 50%;
                background-color: @hong;
                color: #fff;
              }
              h2 {
                margin-top: 2px;
                padding: 0px 3px;
                // border: 1px solid #000;
                text-align: center;
                width: 100%;
                word-break: break-all;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                font-size: 13px;
                height: 37px;
              }
            }
          }
        }
      }
    }
  }
  /deep/.add-pop.pop-team {
    // 新增对话框
    .el-dialog {
      .el-dialog__body {
        padding: 0px;
        .left-box {
          .el-form-item {
            margin-bottom: 0px;
          }
          .iconPng {
            margin-right: 0px;
          }
          .input-bot .el-input__inner {
            border: 0px solid #000;
            border-bottom: 1px solid #dcdfe6;
            text-align: center;
            font-size: 14px;
            width: 65%;
          }
          .stulist {
            margin-top: 18px;
            border: 1px solid #eee;
            overflow: auto;
            height: 300px;
            .tag-stu {
              width: 90%;
              text-align: left;
              padding: 0 10px;
              margin-bottom: 8px;
              .el-icon-close {
                float: right;
                margin-top: 8px;
              }
            }
          }
        }
        .right-box {
          height: 500px;
          min-width: 500px;
          overflow: auto;
          box-sizing: border-box;
          width: 67%;
          // border: 1px solid rgb(226, 5, 5);
          padding: 25px 20px;
          h1 {
            font-size: 15px;
            height: 30px;
            span {
              margin-left: 15px;
              font-size: 14px;
            }
          }
          .no-grou{
            font-size: 20px;
          }
          .box {
            cursor: pointer;
            width: 100px;
            height: 100px;
            // border: 1px solid rgb(136, 131, 131);
            margin: 0px 10px 10px 0px;
            padding: 2px;
            border-radius: 5px;
            box-sizing: border-box;
            text-align: center;
            .iconPng {
              // border: 1px solid #eee;
              width: 70px;
              height: 70px;
              border-radius: 50%;
            }
            .score-rel {
              position: relative;
              left: 0px;
              top: 0px;
              .score {
                position: absolute;
                right: -2px;
                top: -2px;
                z-index: 2;
                border: 0px solid #000;
              }
              .el-checkbox.is-bordered {
                height: 100px;
                width: 100px;
                .el-checkbox__input {
                  left: 37px;
                  top: -6px;
                  .el-checkbox__inner {
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                  }
                  .el-checkbox__inner::after {
                    border: 3px solid #fff;
                    left: 6px;
                    top: 3px;
                    border-left: 0;
                    border-top: 0;
                  }
                }
              }
              .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label {
                opacity: 0;
                width: 1px;
                overflow: hidden;
              }
            }
            h1 {
              font-size: 13px;
              height: 16px;
            }
          }
          .box:hover {
            border: 0.5px solid rgb(228, 221, 221);
          }
          .img-box {
            overflow: auto;
            height: 380px;
            // border: 1px solid rgb(216, 7, 7);
            .iconPng {
              cursor: pointer;
              float: left;
              // border: 1px solid #eee;
              width: 76px;
              height: 76px;
              border-radius: 50%;
              margin: 5px;
            }
            .iconPng:hover {
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            }
          }
        }
      }
    }
  }
  /deep/.add-pop.pop-team-eva {
    .el-dialog {
      .el-dialog__body {
        padding: 0px 10px;
      }
      .right-box {
        padding: 10px 15px;
        width: 100%;
        // border: 1px solid rgb(211, 40, 40);
        .edit-btn {
          margin-right: 15px;
        }
        .but-all {
          // border: 1px solid #000;
          margin-bottom: 10px;
        }
        .elv-tema-box {
          height: 450px;
          overflow: auto;
          // border: 1px solid #000;
          .box {
            cursor: pointer;
            width: 100px;
            height: 110px;
            // border: 1px solid rgb(253, 33, 33);
            margin: 7px;
            padding: 2px 3px;
            border-radius: 5px;
            box-sizing: border-box;
            text-align: center;

            .check-select {
              position: relative;
              left: 0px;
              top: 0px;
              z-index: 20;
              .check-box {
                z-index: 20;
                position: absolute;
                right: -2px;
                top: -2px;
                z-index: 2;
                border: 0px solid #000;
              }
            }
            .el-checkbox.is-bordered {
              height: 110px;
              width: 100px;
              .el-checkbox__input {
                left: 37px;
                top: -6px;
                .el-checkbox__inner {
                  border-radius: 50%;
                  width: 20px;
                  height: 20px;
                }
                .el-checkbox__inner::after {
                  border: 3px solid #fff;
                  left: 6px;
                  top: 3px;
                  border-left: 0;
                  border-top: 0;
                }
              }
            }
            .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label {
              opacity: 1;
              width: 1px;
              overflow: hidden;
            }
            .iconPng {
              // border: 1px solid #eee;
              width: 70px;
              height: 70px;
              border-radius: 50%;
            }
            .score {
              // border: 1px solid #000;
              margin-top: -11px;
              .el-col {
                width: 43px;
                height: 20px;
                line-height: 20px;
                color: white;
                font-size: 14px;
              }
              .jia {
                border-radius: 10px 0 0 10px;
                background-color: @color;
                // border: 1px solid rgb(76, 38, 146);
              }
              .jian {
                border-radius: 0px 10px 10px 0px;
                background-color: @zong;
                // border: 1px solid rgb(209, 31, 31);
              }
            }
            h1 {
              margin-top: 5px;
              // border: 1px solid #000;
              font-size: 13px;
            }
          }
          .box:hover {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          }
        }
      }
      .allselect-btn {
        float: left;
        // border: 1px solid #000;
        margin-top: 5px;
        margin-left: 20px;
      }
      .sub-btn {
        width: 90px;
        margin: 0px 45% 0px 6%;
      }
    }
  }
  /deep/.add-pop.pop-team-scheme {
    // 新增对话框
    .el-dialog {
      width: 40%;
      min-width: 550px;
    }
  }
}
</style>
